import React from 'react';

import { DateChangeHandler, ParnDateField } from './ParnDateField';
import ParnInputField from './ParnInputField';

interface SoldFieldsProps {
  date: Date | moment.Moment | undefined;
  handleDateChange: DateChangeHandler;
  priceData: {
    sold_price?: number;
    gross_commission?: number;
  };
  handlePriceDataChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SoldFields: React.FC<SoldFieldsProps> = ({
  date,
  handleDateChange,
  priceData,
  handlePriceDataChange,
}) => {
  return (
    <>
      <ParnDateField
        id="close_date"
        label="Close date"
        value={date}
        onChangeHandler={handleDateChange}
      />
      <ParnInputField
        label="Sold price"
        id="sold_price"
        name="sold_price"
        placeholder="$###,###"
        value={priceData.sold_price}
        eventHandler={handlePriceDataChange}
        analyticsName="parn-sold-price-input"
      />
      <ParnInputField
        label="Gross commission"
        id="gross_commission"
        name="gross_commission"
        placeholder="$###,###"
        value={priceData.gross_commission}
        eventHandler={handlePriceDataChange}
        analyticsName="parn-gross-commission-input"
      />
    </>
  );
};
